/***
 * @file:å¯ææ¬ç¼è¾å¨
 * @author: linkun.he
 * @Date: 2020-05-11 15:13:07
 */
import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { ControlValueAccessorService } from '../../control-value-accessor.service';

// import { customInputControlValueAccessor } from '../../../utils/form.utils';

@Component({
  selector: 'dt-form-rich-editor',
  templateUrl: './form-rich-editor.component.html',
  styleUrls: ['./form-rich-editor.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormRichEditorComponent),
      multi: true,
    },
  ],
})
export class FormRichEditorComponent extends ControlValueAccessorService {
  value;
  @Input() prop = '';
  // ä¸ä¼ æä»¶çå°å
  @Input() uploadUrl = '/cli/bus/file/upload.do';
  // ä¸è½½æä»¶çå°å
  @Input() downloadUrl = '/cli/bus/file/download.do';
  @Input() height = '320';
  @Input() editModel: any;
  @Output() valueChange = new EventEmitter<any>();
  @Output() imgUpload = new EventEmitter<any>();

  editorChange(value) {
    this.writeValue(value);
    this.updateChanges();
    this.valueChange.emit(this.value);
  }

  onImgUpload(evt) {
    this.imgUpload.emit(evt);
  }
}
